import axios from 'axios';
import $config from '@/config'
import * as Cookies from 'tiny-cookie'

var eventLog = (event, context, payload) => {
  let registration = context.rootGetters['registrations/getCopy'];
  let webcast = context.rootGetters['webcast/getCopy'];
  let device = context.rootGetters['devices/getCopy'];
  let connection = context.rootGetters['session-connections/getCopy']; 
  let stream = context.rootGetters['stream/getCopy'];

  if(webcast) {
    payload['webcastId'] = webcast._id
    payload['sessionId'] = webcast.currentSessionId
  }
  if(device) {
    payload['deviceId'] = device._id
    payload['device'] = device
  }
  if(stream) {payload['streamId'] = stream._id}
  if(registration) {payload['reg'] = registration}
  if(connection) {payload['connection'] = connection}
  
  payload['cookie'] = Cookies.get('lvcstdvc')


  axios.post($config.feathersServer+'/connection-status/',{data:payload, event: event}).then((rec)=>{
    
  });
}

export default eventLog